import React from 'react';
import { ButtonWrapper } from './style';
import { Button } from 'antd';

export default ({ icon, text, onClick, htmlType, ...rest }) => {
  return (
    <ButtonWrapper {...rest}>
      <Button
        htmlType={htmlType}
        type='primary'
        icon={icon && icon}
        onClick={onClick}
        {...rest}
      >
        {text}
      </Button>
    </ButtonWrapper>
  );
};
